export const vehicleStatusConfig = {
  Active: {
    styles: 'text-green-900 bg-green-200',
    dotColor: 'bg-green-500',
  },
  Inactive: {
    styles: 'text-red-900 bg-red-200',
    dotColor: 'bg-red-500',
  },
  Maintenance: {
    styles: 'text-yellow-900 bg-yellow-200',
    dotColor: 'bg-yellow-500',
  },
  Down: {
    styles: 'text-gray-900 bg-gray-300',
    dotColor: 'bg-gray-500',
  },
  // Add other statuses here
};
